module.exports = __webpack_public_path__ + "img/bg-blue.563b86df.png";